import React, { useEffect, useState } from "react";
import { Button } from "antd";

import { getPrinters, printNonLabelItemInOrder } from "../../utils/Print";
import { Order } from "../../../types/model";

interface PrintNonLabelItemButtonProps {
  className?: string;
  style?: React.CSSProperties;
  size?: "small" | "middle" | "large";
  disabled?: boolean;
  handleError: (err: Error) => void;
  children: React.ReactNode;
  order: Order;
}

// Prints labels for all items that don't usually don't print label (e.g. bentos).
const PrintNonLabelItemButton: React.FC<PrintNonLabelItemButtonProps> = ({
  className,
  style,
  size,
  disabled: disabledProp,
  handleError,
  children,
  order,
}) => {
  const [loading, setLoading] = useState(false);
  const [printerUnavailable, setPrinterUnavailable] = useState(true);

  // Test to see if we can reach the print agent.
  useEffect(() => {
    getPrinters((_: any, err?: Error) => {
      if (err) {
        // Do nothing, do not enable the button.
      } else {
        setPrinterUnavailable(false);
      }
    });
  }, [order]);

  return (
    <Button
      type="primary"
      disabled={disabledProp || printerUnavailable}
      loading={loading}
      className={className}
      style={style}
      size="large"
      onClick={() => {
        setLoading(true);
        printNonLabelItemInOrder(
          order,
          () => {
            setLoading(false);
          },
          (err) => {
            setLoading(false);
            handleError(err);
          }
        );
      }}
    >
      {children}
    </Button>
  );
};

export default PrintNonLabelItemButton;
